import api from "./api";

export default {
  mixins: [ api ],
  methods: {
    // Получение списка начислений
    async getAccruals(data) {
      let params = this.makeSearchParams(data);

      if (data.period) {
        params.set("period", data.period);
      }

      if (data.org_id > 0) {
        params.set("org_id", data.org_id);
      }

      return await this.get(`accruals?${params.toString()}`);
    },
    // Получение начисления по id
    async getAccrualById(id) {
      return await this.get(`accruals/${id}`);
    },
    // Создание начисления
    async postAccrual(data) {
      return await this.post('accruals', data);
    },
    // Изменение начисления
    async putAccrual(data) {
      return await this.put(`accruals/${data.id}`, data);
    },
    // Получение нового начиселения по сотруднику за период
    async getNewAccrualStaff(data) {
      let params = this.makeSearchParams(data);

      if (data.period) {
        params.set("period", data.period);
      }
      if (data.staff_id) {
        params.set("staff_id", data.staff_id);
      }

      if (data.accrual_type_id) {
        params.set("accrual_type_id", data.accrual_type_id);
      }

      return await this.get(`accrual_staff/accrual?${params.toString()}`);
    },
  }
}



// WEBPACK FOOTER //
// ./src/network/accruals.js